var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0186 8.66484C20.2981 8.94421 20.4995 9.2919 20.6028 9.67327C21.1973 12.0652 21.0599 15.8429 20.6143 18.3271C20.5111 18.7085 20.3097 19.0562 20.0301 19.3355C19.7506 19.6149 19.4028 19.8162 19.0212 19.9194C17.6244 20.3002 12.0024 20.3002 12.0024 20.3002C12.0024 20.3002 6.38048 20.3002 4.98365 19.9194C4.60209 19.8162 4.25423 19.6149 3.97473 19.3355C3.69522 19.0562 3.49381 18.7085 3.39057 18.3271C2.79258 15.9456 2.95651 12.1656 3.37902 9.68481C3.48227 9.30344 3.68368 8.95575 3.96318 8.67638C4.24269 8.39701 4.59054 8.1957 4.9721 8.0925C6.36893 7.71173 11.9909 7.7002 11.9909 7.7002C11.9909 7.7002 17.6129 7.7002 19.0097 8.08096C19.3912 8.18416 19.7391 8.38547 20.0186 8.66484ZM14.8656 14.0002L10.2018 16.7002V11.3002L14.8656 14.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d95173414862d139d2de7c6eb6c4edfc.svg";
export { ForwardRef as ReactComponent };